export const $ = n => n == null ? '$0' : '$' + Math.abs(n).toLocaleString('en-US', {minimumFractionDigits:0,maximumFractionDigits:0});
export const fd = d => { if(!d) return '—'; try { const dt = new Date(d); return isNaN(dt) ? '—' : dt.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}); } catch { return '—'; } };
export const dl = d => { if(!d) return 0; const diff = new Date(d) - new Date(); return Math.max(0, Math.ceil(diff / 86400000)); };
export const td = () => new Date().toISOString().split('T')[0];
export const uid = () => Math.random().toString(36).slice(2,10);
export const TIERS = {
  starter: { name:'Starter', price:29, units:5 },
  pro:     { name:'Pro',     price:49, units:20 },
  portfolio:{ name:'Portfolio',price:99,units:999 }
};
export const C = {};
